import axios from 'axios';
const auth = {

    state: {
		status: '', 
		token: localStorage.getItem('token') || '', 
		userdata : null,
		user_fullName: '',
		user_phone:'',
		user_email:'',
		user_passport:'',
		user_status_id:'',	
		username:'',
		accesskey: 'DxaGiSPm/CKRlSaPQnKCv3rQvV5Rj7MoPdHcZ79UvQg=',
		baseurl:'http://localhost/churchdockapi'
				
	},	
	mutations: {
		auth_request(state){
			state.status = 'loading';
		},
		auth_success(state, {token, user_fullName, user_phone, user_email, user_passport, user_status_id}){
			state.status = 'success'
			state.token = token			
			state.user_fullName = user_fullName
			state.user_phone=user_phone
			state.user_email=user_email
			state.user_passport= user_passport
			state.user_status_id = user_status_id			
		},
		auth_username(state, username){
			state.status = 'yet to logon'
			state.username = username		
		},
		auth_error(state){
			state.status = 'error'
		},
		logout(state){
			state.status = ''
			state.token = ''
		},
		
	},
	actions: {
	
		login({commit, rootState}, userdata){
			return new Promise((resolve, reject) => {
				commit('auth_request')
				commit('auth_username',userdata.username)
				axios({url: '/account/userlogin', data: userdata, method: 'POST' })
				.then(resp => resp.data)
				.then(loginuser => {
					const token = loginuser.Username;
					const user_fullName = loginuser.FullName;
					const user_phone = loginuser.PhoneNo;
					const user_email = loginuser.EmailAddress;					
					let user_passport = null;
					if(loginuser.PassportPath!=null){
						user_passport=	rootState.auth.baseurl + loginuser.PassportPath.substr(1)
					}
					
					const user_status_id = loginuser.UserRoleId;
					localStorage.setItem('token', token);
					// Add the following line:
					axios.defaults.headers.common['Authorization'] = token
					commit('auth_success',{token, user_fullName, user_phone, user_email, user_passport, user_status_id});					
					resolve(loginuser)
				})
				.catch(err => {
					commit('auth_error')
					localStorage.removeItem('token')
					reject(err)
				})
			})
		},
		resetpassword({commit}, userdata){
			return new Promise((resolve, reject) => {
				commit('auth_request')
				axios({url: '/account/Retrivepassword', data: userdata, method: 'POST' })
				.then(resp => resp.data)
				.then(loginuser => {
					resolve(loginuser)
				})
				.catch(err => {
					commit('auth_error')
					localStorage.removeItem('token')
					reject(err)
				})
			})
		},
		changepassword({commit}, userdata){
			return new Promise((resolve, reject) => {
				commit('auth_request')
				axios({url: '/account/Changepassword', data: userdata, method: 'POST' })
				.then(resp => resp.data)
				.then(loginuser => {
					resolve(loginuser)
				})
				.catch(err => {
					commit('auth_error')
					localStorage.removeItem('token')
					reject(err)
				})
			})
		},
		studentsignup(context, userdata){
			return new Promise((resolve, reject) => {				
				axios({url: '/account/Studentsignup', data: userdata, method: 'POST' })
				.then(resp => resp.data)
				.then(res => {
					resolve(res)
				})
				.catch(err => {					
					reject(err)
				})
			})
		},
		schoolsignup(context, userdata){
			return new Promise((resolve, reject) => {				
				axios({url: '/account/Schoolsignup', data: userdata, method: 'POST' })
				.then(resp => resp.data)
				.then(res => {
					resolve(res)
				})
				.catch(err => {					
					reject(err)
				})
			})
		},
		logout({commit}){
			return new Promise((resolve) => {
				commit('logout')
				localStorage.removeItem('token')
				delete axios.defaults.headers.common['Authorization']
				resolve()
			})
		}
	},
	getters : {
		isLoggedIn: state => !!state.token,
		authStatus: state => state.status		
	}
}

export default auth